import Error from "../../components/Error";

const _Error = () => {
    return (
        <>
            <Error/>
        </>
    )
}

export default _Error;